<template functional>
    <div v-show="props.isLoading" :class="{ 'loading-spinner--dark': props.lightBg }" class="loading-spinner">
        <div class="loading-spinner__dot dot-1"></div>
        <div class="loading-spinner__dot dot-2"></div>
        <div class="loading-spinner__dot dot-3"></div>
        <div class="loading-spinner__dot dot-4"></div>
        <div class="loading-spinner__dot dot-5"></div>
        <div class="loading-spinner__dot dot-6"></div>
        <div class="loading-spinner__dot dot-7"></div>
        <div class="loading-spinner__dot dot-8"></div>
        <div class="loading-spinner__dot dot-9"></div>
        <div class="loading-spinner__dot dot-10"></div>
        <div class="loading-spinner__dot dot-11"></div>
        <div class="loading-spinner__dot dot-12"></div>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        lightBg: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
